export const EXTERNAL_URLS = {
  BOT: "https://t.me/phodo_management",
  SUPPORT: "https://t.me/phodo_management"
};

/**
 * Публикация юридических документов.
 *
 * Все документы лежат в одном месте — на публичном сайте, а не внутри приложения.
 * Так на них можно сослаться из оферты, из письма и из переписки, и ссылка не
 * зависит от того, открыто ли приложение.
 *
 * Адреса латиницей намеренно: прежние файлы назывались по-русски, и ссылки на них
 * ломались на кодировании кириллицы в адресе — документы просто не открывались.
 */
const LEGAL_BASE = "https://link.phodo.ru/legal";

export const LAW_DOCUMENTS = {
  /** Оглавление: все документы одним списком */
  INDEX: `${LEGAL_BASE}/`,
  USER_AGREEMENT: `${LEGAL_BASE}/user-agreement.pdf`,
  PRIVACY_POLICY: `${LEGAL_BASE}/privacy`,
  USER_CONSENT: `${LEGAL_BASE}/consent`,
  OFFER: `${LEGAL_BASE}/offer`,
  /** Бонусы, бесплатная печать и промокоды: принимается при регистрации */
  BONUS_RULES: `${LEGAL_BASE}/bonus-rules`,
  /** Приглашения, уровни и награды: принимается при регистрации */
  REFERRAL_RULES: `${LEGAL_BASE}/referral-rules`,
  /** Второй и третий уровни: вознаграждение деньгами */
  PARTNER_OFFER: `${LEGAL_BASE}/partner-offer`,
  /** Что подписывает партнёр перед первой выплатой */
  PARTNER_CONSENT: `${LEGAL_BASE}/partner-consent`
};
